// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r8xc","name":"styles_name__2m4zf","phone":"styles_phone__1TCFb"};